/* Terashack collection filters: auto-apply on desktop, drawer on mobile (<= 820px). */
(function () {
  var desktop = window.matchMedia('(min-width: 821px)');

  var sort = document.querySelector('[data-ts-sort]');
  if (sort) sort.addEventListener('change', function () { sort.form.submit(); });

  var form = document.querySelector('[data-ts-filter-form]');
  if (form) {
    form.addEventListener('change', function (e) {
      if (!desktop.matches) return; // in the drawer the buyer presses "Show results"
      if (e.target.type === 'number' && e.target.value !== '' && !e.target.checkValidity()) return;
      form.submit();
    });
  }

  var rail = document.querySelector('[data-ts-rail]');
  var openBtn = document.querySelector('[data-ts-rail-open]');
  var overlay = document.querySelector('[data-ts-rail-overlay]');
  if (!rail || !openBtn) return;
  var closeBtn = rail.querySelector('[data-ts-rail-close]');

  function focusables() {
    return Array.prototype.filter.call(
      rail.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null || el === document.activeElement; }
    );
  }
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function open() {
    rail.classList.add('is-open');
    rail.setAttribute('role', 'dialog');
    rail.setAttribute('aria-modal', 'true');
    if (overlay) overlay.hidden = false;
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    setTimeout(function () { (closeBtn || focusables()[0]).focus(); }, 30);
  }
  function close() {
    if (!rail.classList.contains('is-open')) return;
    rail.classList.remove('is-open');
    rail.removeAttribute('role');
    rail.removeAttribute('aria-modal');
    if (overlay) overlay.hidden = true;
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    openBtn.focus();
  }
  openBtn.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);
  desktop.addEventListener('change', function (e) { if (e.matches) close(); });
})();
